import { Input } from 'antd';
import React from 'react';
import type { RegisterOptions } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

import type { InputNoteConfig } from '../_common';
import {
  getHookFieldClass,
  getHookGroupClass,
  renderErrorMessage,
  renderHookInputHeader
} from '../_common';

interface TextAreaInputProps {
  label?: string;
  name: string;
  required?: boolean;
  placeholder?: string;
  minRows?: number;
  disabled?: boolean;
  options?: RegisterOptions;
  inputNote?: InputNoteConfig;
  hideLabel?: boolean;
}

const TextAreaInput = ({
  name,
  disabled,
  label,
  minRows,
  options,
  placeholder,
  required,
  inputNote,
  hideLabel
}: TextAreaInputProps) => {
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error, isTouched } = getFieldState(name, formState);

  const showError = !!error && isDirty;

  return (
    <div className={getHookGroupClass(label, 'TextAreaInput')}>
      {!hideLabel && renderHookInputHeader(name, label, required, inputNote)}
      <Controller
        name={name}
        control={control}
        rules={options}
        render={({ field }) => (
          <Input.TextArea
            {...field}
            id={name}
            placeholder={placeholder}
            autoSize={{ minRows: minRows || 4 }}
            className={getHookFieldClass(isTouched, invalid)}
            disabled={disabled}
          />
        )}
      />
      {renderErrorMessage(showError, error?.message)}
    </div>
  );
};

export default TextAreaInput;
